import { Spacings, SpacingsValues } from '@picsart/design-system/foundation/spacings';

const head = document.getElementsByTagName('head')[0];

const spacingStyleClassName = 'pa-radius-theme';

const spacings = Spacings;

const updateSpacings = () => {
  const style = document.createElement('style');
  style.classList.add(spacingStyleClassName);

  style.innerText = `
    :root {
      ${Object.entries(SpacingsValues).reduce((acc, [spacing, value]) => `${acc}${spacing}: ${value};\n`, '')}
    }
  `;

  head.appendChild(style);

  return () => {
    head.removeChild(style);
  };
};

export { spacings, updateSpacings };
